<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Samples"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <l-csv-import @on-import="onImportSamples" />
    </l-container>

    <l-csv-export :exportPlugin="exportPlugin" :show="samples.length > 0" filename="samples" />

    <hot-table :data="samples" :settings="settings" ref="hot">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column title="inlet_height" data="inlet_height" read-only="true"></hot-column>
      <hot-column title="building_distance" data="building_distance" read-only="true"></hot-column>
      <hot-column title="kerb_distance" data="kerb_distance" read-only="true"></hot-column>
    </hot-table>
    <l-l-edit
      :showing="edit"
      @save="onSaveSamples"
      @close="edit = false"
      :samples="samples"
      :selected="selected"
      :isnew="isnew"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import SamplesService from "./samples.service";
import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";
import LCsvExport from '@/components/LCsvExport.vue';

export default {
  name: "samples",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport,
    LCsvExport
  },
  data() {
    return {
      edit: false,
      loading: false,
      samples: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      isnew: false,
      selected: {},
      exportPlugin: {}
    };
  },
  mounted() {
    //this.settings.afterSelectionEnd = this.selectRowOnly;
    this.exportPlugin = this.$refs.hot.hotInstance.getPlugin("exportFile");
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.samples = await SamplesService.samples();
    },
    // async deleteSamples(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await Samples.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Samples deleted!");
    //   }
    // },
    async saveSamples(ra) {
      const rowsAffected = await SamplesService.update(ra);
      console.log("SAVED TO DB");
      const current = this.samples.find(n => n.id == ra.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && ra[prop]) {
            current[prop] = ra[prop];
          }
        }
      }
    },
    async importSamples(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await SamplesService.import(formData);
      this.samples = await SamplesService.samples();
      Notify.success("Samples imported!");
    },
    async onImportSamples(file) {
      await Notify.loadData("Importing samples", this.importSamples, file);
    },
    onEditSamples(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.isnew = false;
      this.edit = true;
    },
    onNewSamples(t, o) {
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = null;
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.isnew = true;
      this.edit = true;
    },
    onDeleteSamples(t, o) {
      const endRow = o[0].end.row;
      const startRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              for (let index = startRow; index < endRow+1; index++) {
                var row = hot.getDataAtRow(index);
                const rowsAffected = await SamplesService.delete(row[0]);
              }
              const activeEditor = hot.getActiveEditor();
              hot.alter('remove_row', startRow, endRow-startRow+1);
            }
          );
          Notify.success("Samples deleted!");
        }
      }, "This will delete all data connected to this Sample(s). <br/><br/>Do you want to continue?");
    },

    async onSaveSamples(samples) {
      await Notify.loadData(
        "Saving changes to Samples " + samples.id,
        this.saveSamples,
        samples
      );
      this.selected = {};
    }
  }
};
</script>

